// FULL-VIOLENCE Blogpost 500 JavaScript
class Blogpost500 {
  constructor(sectionId) {
    this.sectionId = sectionId;
    this.data = window.blogpost500Data[sectionId];

    if (!this.data) {
      console.warn(`Blogpost 500 data not found for section ${sectionId}`);
      return;
    }

    // State management
    this.currentFilter = 'all';
    this.currentPage = 1;
    this.itemsPerPage = this.data.settings.itemsPerPage || 12;
    this.searchTerm = '';
    this.sortOrder = 'newest';
    this.filteredData = [...this.data.blocks];

    // DOM elements
    this.container = document.getElementById(`blogpost-500-${sectionId}`);
    this.contentGrid = document.getElementById(`contentGrid-${sectionId}`);
    this.filterTabs = this.container.querySelectorAll('.filter-tab');
    this.searchInput = document.getElementById(`searchInput-${sectionId}`);
    this.sortSelect = document.getElementById(`sortSelect-${sectionId}`);
    this.videoModal = document.getElementById(`videoModal-${sectionId}`);
    this.videoFrame = document.getElementById(`videoFrame-${sectionId}`);
    this.closeModal = this.container.querySelector('.close-modal');
    this.noResults = document.getElementById(`noResults-${sectionId}`);
    this.pagination = document.getElementById(`pagination-${sectionId}`);
    this.pageNumbers = document.getElementById(`pageNumbers-${sectionId}`);
    this.prevBtn = document.getElementById(`prevBtn-${sectionId}`);
    this.nextBtn = document.getElementById(`nextBtn-${sectionId}`);
    this.searchResultsText = document.getElementById(`searchResultsText-${sectionId}`);

    this.init();
  }

  init() {
    this.setupEventListeners();
    this.setupVideoCardListeners();
    this.renderMedia();
  }

  setupVideoCardListeners() {
    // Listen for clicks on video cards to intercept and show modal
    if (this.container) {
      this.container.addEventListener('click', (e) => {
        const card = e.target.closest('.blog-card[data-type="video"], .video-card[data-type="video"]');
        if (card) {
          e.preventDefault();
          const articleUrl = card.dataset.articleUrl;
          if (articleUrl) {
            this.fetchAndShowVideo(articleUrl);
          }
        }
      });
    }
  }

  async fetchAndShowVideo(articleUrl) {
    try {
      console.log('Fetching article:', articleUrl);
      // Fetch the article page
      const response = await fetch(articleUrl);
      const html = await response.text();

      // Parse HTML to extract iframe
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const iframe = doc.querySelector('iframe[src*="youtube.com"], iframe[src*="youtu.be"], iframe[src*="vimeo.com"]');

      console.log('Found iframe:', iframe);

      if (iframe && iframe.src) {
        // Get the iframe src and ensure it has autoplay
        let videoUrl = iframe.src;
        console.log('Original video URL:', videoUrl);

        const separator = videoUrl.includes('?') ? '&' : '?';
        if (!videoUrl.includes('autoplay=')) {
          videoUrl += separator + 'autoplay=1';
        }

        console.log('Opening modal with URL:', videoUrl);
        this.openVideoModal(videoUrl);
      } else {
        console.log('No iframe found, navigating to article');
        // If no iframe found, just navigate to the article
        window.location.href = articleUrl;
      }
    } catch (error) {
      console.error('Error fetching video:', error);
      // Fallback to navigating to article
      window.location.href = articleUrl;
    }
  }

  setupEventListeners() {
    // Filter tabs
    if (this.data.settings.enableFilters && this.filterTabs.length > 0) {
      this.filterTabs.forEach(tab => {
        tab.addEventListener('click', () => {
          const filter = tab.dataset.filter;
          this.setActiveFilter(filter);
        });
      });
    }

    // Search input with debounce
    if (this.data.settings.enableSearch && this.searchInput) {
      let searchTimeout;
      this.searchInput.addEventListener('input', (e) => {
        clearTimeout(searchTimeout);
        const value = e.target.value;

        // Only search if 3 or more characters or empty
        if (value.length >= 3 || value.length === 0) {
          searchTimeout = setTimeout(() => {
            this.searchTerm = value.toLowerCase();
            this.filterAndRender();
          }, 300);
        }
      });
    }

    // Sort select
    if (this.data.settings.enableSearch && this.sortSelect) {
      this.sortSelect.addEventListener('change', (e) => {
        this.sortOrder = e.target.value;
        this.filterAndRender();
      });
    }

    // Modal close
    if (this.closeModal) {
      this.closeModal.addEventListener('click', () => this.closeVideoModal());
    }

    if (this.videoModal) {
      this.videoModal.addEventListener('click', (e) => {
        if (e.target === this.videoModal) {
          this.closeVideoModal();
        }
      });
    }

    // Pagination
    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', () => {
        if (this.currentPage > 1) {
          this.currentPage--;
          this.renderMedia();
        }
      });
    }

    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', () => {
        const totalPages = Math.ceil(this.filteredData.length / this.itemsPerPage);
        if (this.currentPage < totalPages) {
          this.currentPage++;
          this.renderMedia();
        }
      });
    }

    // Reset search button
    const resetSearchBtn = document.getElementById(`resetSearchBtn-${this.sectionId}`);
    if (resetSearchBtn) {
      resetSearchBtn.addEventListener('click', () => {
        if (this.searchInput) {
          this.searchInput.value = '';
        }
        this.searchTerm = '';
        this.filterAndRender();
      });
    }

    // Keyboard navigation for modal
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.videoModal && this.videoModal.classList.contains('active')) {
        this.closeVideoModal();
      }
    });
  }

  setActiveFilter(filter) {
    this.currentFilter = filter;
    this.currentPage = 1;

    // Update tab styles
    this.filterTabs.forEach(tab => {
      tab.classList.remove('active');
      if (tab.dataset.filter === filter) {
        tab.classList.add('active');
      }
    });

    this.filterAndRender();
  }

  filterAndRender() {
    // Apply filters
    this.filteredData = this.data.blocks.filter(item => {
      // Type filter
      if (this.currentFilter !== 'all' && item.type !== this.currentFilter.replace('_item', '')) {
        return false;
      }

      // Search filter
      if (this.searchTerm &&
          !item.title.toLowerCase().includes(this.searchTerm) &&
          !item.category.toLowerCase().includes(this.searchTerm)) {
        return false;
      }

      return true;
    });

    // Apply sorting
    this.filteredData.sort((a, b) => {
      const dateA = new Date(this.parseDate(a.date));
      const dateB = new Date(this.parseDate(b.date));

      if (this.sortOrder === 'newest') {
        return dateB - dateA;
      } else {
        return dateA - dateB;
      }
    });

    // Update search results text
    this.updateSearchResultsText();

    this.currentPage = 1;
    this.renderMedia();
  }

  updateSearchResultsText() {
    if (!this.searchResultsText) return;

    if (this.searchTerm && this.searchTerm.length >= 3) {
      // Show the search results text
      this.searchResultsText.style.display = 'block';
      const searchTermSpan = this.searchResultsText.querySelector('.search-term');
      if (searchTermSpan) {
        searchTermSpan.textContent = this.searchTerm;
      }
    } else {
      // Hide the search results text
      this.searchResultsText.style.display = 'none';
    }
  }

  parseDate(dateString) {
    // Convert "SEP 17, 2024" format to proper date
    const months = {
      'JAN': 0, 'FEB': 1, 'MAR': 2, 'APR': 3, 'MAY': 4, 'JUN': 5,
      'JUL': 6, 'AUG': 7, 'SEP': 8, 'OCT': 9, 'NOV': 10, 'DEC': 11
    };

    const parts = dateString.split(' ');
    if (parts.length === 3) {
      const month = months[parts[0]];
      const day = parseInt(parts[1].replace(',', ''));
      const year = parseInt(parts[2]);
      return new Date(year, month, day);
    }

    return new Date(dateString);
  }

  renderMedia() {
    // Calculate pagination
    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    const endIndex = startIndex + this.itemsPerPage;
    const paginatedData = this.filteredData.slice(startIndex, endIndex);

    // Clear grid
    if (this.contentGrid) {
      this.contentGrid.innerHTML = '';
    }

    // Check if no results
    if (paginatedData.length === 0) {
      if (this.noResults) {
        this.noResults.style.display = 'flex';
      }
      if (this.pagination) {
        this.pagination.style.display = 'none';
      }
      return;
    } else {
      if (this.noResults) {
        this.noResults.style.display = 'none';
      }
      if (this.pagination) {
        this.pagination.style.display = 'flex';
      }
    }

    // Render items
    paginatedData.forEach(item => {
      const card = this.createMediaCard(item);
      if (card && this.contentGrid) {
        this.contentGrid.appendChild(card);
      }
    });

    this.updatePagination();
  }

  createMediaCard(item) {
    const itemType = item.type.replace('_item', '');
    const wrapper = document.createElement('div');
    wrapper.className = 'media-card-wrapper';

    // Create meta above card
    const metaAbove = document.createElement('div');
    metaAbove.className = 'card-meta-above';
    metaAbove.innerHTML = `
    <div class="meta-ball"></div>
      <span class="category-tag">${item.category || ''}</span>
      <span class="separator">•</span>
      <span class="date">${item.date || ''}</span>
    `;

    let card;

    if (itemType === 'video') {
      card = document.createElement('div');
      card.className = 'video-card media-card';
      card.innerHTML = `
        <div class="video-thumbnail">
          <img src="${item.thumbnail || ''}" alt="${item.title || ''}" loading="lazy">
          <div class="play-button">
            <div class="play-icon"></div>
          </div>
        </div>
        <div class="video-content">
          <div class="video-meta">
            <span class="category-tag">${item.category || ''}</span>
            <span class="separator">•</span>
            <span class="date">${item.date || ''}</span>
          </div>
          <h3 class="video-title">${item.title || ''}</h3>
        </div>
      `;

      card.addEventListener('click', () => {
        if (item.videoUrl) {
          this.openVideoModal(item.videoUrl);
        }
      });
    } else {
      // Blog or news item - create as <a> tag
      card = document.createElement('a');
      const cardClass = itemType === 'news' ? 'news-card' : 'blog-card';
      card.className = `${cardClass} media-card`;
      card.href = item.link || '#';
      card.style.textDecoration = 'none';
      card.style.color = 'inherit';
      card.style.display = 'block';
      card.innerHTML = `
        <div class="${itemType}-thumbnail">
          <img src="${item.thumbnail || ''}" alt="${item.title || ''}" loading="lazy">
        </div>
        <div class="${itemType}-content">
          <div class="video-meta">
            <span class="category-tag">${item.category || ''}</span>
            <span class="separator">•</span>
            <span class="date">${item.date || ''}</span>
          </div>
          <h3 class="${itemType}-title">${item.title || ''}</h3>
          <div class="read-story">
            READ STORY
            <span class="arrow-icon">→</span>
          </div>
        </div>
      `;
    }

    // Add dataset for filtering
    card.dataset.type = itemType;
    card.dataset.category = item.category || '';
    card.dataset.title = item.title || '';
    card.dataset.date = item.date || '';

    wrapper.appendChild(metaAbove);
    wrapper.appendChild(card);

    return wrapper;
  }

  openVideoModal(videoUrl) {
    console.log('openVideoModal called with:', videoUrl);
    console.log('Modal element:', this.videoModal);
    console.log('Frame element:', this.videoFrame);

    if (this.videoModal && this.videoFrame) {
      this.videoModal.classList.add('active');
      // Ensure autoplay parameter is included
      const separator = videoUrl.includes('?') ? '&' : '?';
      if (!videoUrl.includes('autoplay=')) {
        this.videoFrame.src = videoUrl + separator + 'autoplay=1';
      } else {
        this.videoFrame.src = videoUrl;
      }
      document.body.style.overflow = 'hidden';
      console.log('Modal opened, iframe src set to:', this.videoFrame.src);
    } else {
      console.error('Modal or frame not found!');
    }
  }

  closeVideoModal() {
    if (this.videoModal && this.videoFrame) {
      this.videoModal.classList.remove('active');
      this.videoFrame.src = '';
      document.body.style.overflow = '';
    }
  }

  updatePagination() {
    if (!this.pageNumbers || !this.prevBtn || !this.nextBtn) {
      return;
    }

    const totalPages = Math.ceil(this.filteredData.length / this.itemsPerPage);

    // Update prev/next buttons
    this.prevBtn.disabled = this.currentPage === 1;
    this.nextBtn.disabled = this.currentPage === totalPages || totalPages === 0;

    // Generate page numbers
    let pagesHTML = '';

    if (totalPages <= 7) {
      // Show all pages if 7 or less
      for (let i = 1; i <= totalPages; i++) {
        pagesHTML += `<span class="page-num ${i === this.currentPage ? 'active' : ''}" data-page="${i}">${i}</span>`;
      }
    } else {
      // Show first, last, and pages around current
      if (this.currentPage <= 3) {
        for (let i = 1; i <= 4; i++) {
          pagesHTML += `<span class="page-num ${i === this.currentPage ? 'active' : ''}" data-page="${i}">${i}</span>`;
        }
        pagesHTML += '<span class="page-dots">...</span>';
        pagesHTML += `<span class="page-num" data-page="${totalPages}">${totalPages}</span>`;
      } else if (this.currentPage >= totalPages - 2) {
        pagesHTML += '<span class="page-num" data-page="1">1</span>';
        pagesHTML += '<span class="page-dots">...</span>';
        for (let i = totalPages - 3; i <= totalPages; i++) {
          pagesHTML += `<span class="page-num ${i === this.currentPage ? 'active' : ''}" data-page="${i}">${i}</span>`;
        }
      } else {
        pagesHTML += '<span class="page-num" data-page="1">1</span>';
        pagesHTML += '<span class="page-dots">...</span>';
        for (let i = this.currentPage - 1; i <= this.currentPage + 1; i++) {
          pagesHTML += `<span class="page-num ${i === this.currentPage ? 'active' : ''}" data-page="${i}">${i}</span>`;
        }
        pagesHTML += '<span class="page-dots">...</span>';
        pagesHTML += `<span class="page-num" data-page="${totalPages}">${totalPages}</span>`;
      }
    }

    this.pageNumbers.innerHTML = pagesHTML;

    // Add click handlers to page numbers
    this.pageNumbers.querySelectorAll('.page-num').forEach(pageNum => {
      pageNum.addEventListener('click', () => {
        const page = parseInt(pageNum.dataset.page);
        if (page && page !== this.currentPage) {
          this.currentPage = page;
          this.renderMedia();
        }
      });
    });
  }
}

// Store instances globally
window.blogpost500Instances = window.blogpost500Instances || {};

// Initialize blogpost 500 sections when DOM is loaded
document.addEventListener('DOMContentLoaded', function() {
  // Initialize all blogpost 500 sections
  if (window.blogpost500Data) {
    Object.keys(window.blogpost500Data).forEach(sectionId => {
      window.blogpost500Instances[sectionId] = new Blogpost500(sectionId);
    });
  }
});

// Handle theme editor updates
document.addEventListener('shopify:section:load', function(event) {
  const sectionId = event.detail.sectionId;
  if (window.blogpost500Data && window.blogpost500Data[sectionId]) {
    window.blogpost500Instances[sectionId] = new Blogpost500(sectionId);
  }
});

// Handle theme editor section reloads
document.addEventListener('shopify:section:reorder', function(event) {
  // Re-initialize all galleries
  if (window.blogpost500Data) {
    Object.keys(window.blogpost500Data).forEach(sectionId => {
      const existingGallery = document.getElementById(`blogpost-500-${sectionId}`);
      if (existingGallery) {
        window.blogpost500Instances[sectionId] = new Blogpost500(sectionId);
      }
    });
  }
});

// Expose Blogpost500 class globally for potential external use
window.Blogpost500 = Blogpost500;
